import React, { useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router";
import { Spinner } from "react-bootstrap";
import { useAuth } from "../components/AuthContext/AuthContext";
import AccountCard from "../stories/Cards/AccountCard";
import { ssoLoginUrl } from "../utils/constants";

// Shared landing page for an SSO-managed HCP account, reached two ways:
//   1. LoginForm.jsx redirects here when a normal email/password login is
//      blocked because the account is SSO-managed.
//   2. ForgotPassword.jsx redirects here when the forgot-password request
//      reveals the account is SSO-managed.
// Both pass router state `{ ssoBlocked: true }` - this page has nothing to
// show without it (e.g. a direct visit, or a refresh that drops in-memory
// router state), so it bounces back to /login rather than rendering blank.
function AccountAccess() {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isSsoBlocked = location.state?.ssoBlocked === true;

  useEffect(() => {
    auth.setTitle("Account access");
    if (!isSsoBlocked) {
      navigate("/login", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSsoBlocked, navigate]);

  // Full-page navigation on purpose - this kicks off the SAML redirect
  // chain through the Boots IdP, not an API call this SPA can read a
  // response from (mirrors LoginForm's handleSsoLogin).
  const handleSsoLogin = () => {
    window.location.assign(ssoLoginUrl);
  };

  if (auth.featureFlagLoading || !isSsoBlocked)
    return (
      <div className="text-center">
        <Spinner
          animation="border"
          variant="info"
          className="my-custom-spinner"
        />
      </div>
    );

  return (
    <div className="login-wrapper">
      <AccountCard
        title="Your account uses single sign-on"
        subtitle="Please sign in with SSO to continue"
        loginPage={true}
      >
        <div className="sso-required-screen">
          <button
            className="sso-login-btn"
            onClick={handleSsoLogin}
            type="button"
          >
            Login with Boots SSO
          </button>
          <div className="forget-password-link back-to-login-link text-center">
            <Link to="/">Back to login</Link>
          </div>
        </div>
      </AccountCard>
    </div>
  );
}

export default AccountAccess;
